<div class="fluid-container p-4">
  <div class="resume-banner">
    <div class="banner-left">
      <h1>Resume Builder</h1>
      <p>Create a professional, ATS-optimized resume in minutes</p>

      <div class="features">
        <span><i class="bi bi-stars me-2"></i> AI-Powered Content</span>
        <span><i class="bi bi-graph-up-arrow me-2"></i> ATS Score Check</span>
        <span><i class="bi bi-download me-2"></i> PDF Download</span>
      </div>
    </div>

    <div class="banner-right">
    <ng-container *hasPermission="PermissionForStudents.RESUME_CREATE">
      <button (click)="goToResumebuilderPage()" class="create-btn">
        + Create New Resume
      </button>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="isLoading; else pageContent">
    <div class="app-spinner">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #pageContent>
    <ng-container *ngIf="studentsResume.length > 0; else noResumeFound">
      <div class="resume-container">
        <div class="d-flex">
          <h2>
            <i class="bi bi-folder"></i>
            Saved Resumes
          </h2>
          <span class="resume-count"> ({{resumeCount}})</span>
        </div>

        <div class="card-container">
          <div class="resume-card" *ngFor="let studentResume of studentsResume">
            <div class="card-preview">
           <div class="bg-layer"></div>
           <img class="resume-img" src="assets/images/resume.png" alt="Resume Preview"/>
            </div>

            <div class="card-body">
              <i
                class="bi bi-pencil-square edit-icon"
                (click)="openEdit(studentResume)"
              ></i>

              <h4 *ngIf="editingResumeId !== studentResume.resume_id">
                {{ studentResume.resume_name }}
              </h4>

              <input
                *ngIf="editingResumeId === studentResume.resume_id"
                type="text"
                [(ngModel)]="editedResumeName"
              />
              <ng-container *hasPermission="PermissionForStudents.RESUME_UPDATE">
              <ng-container *ngIf="editingResumeId === studentResume.resume_id">
                <i
                  class="bi bi-check save-icon ms-2"
                  (click)="updateResumeName(studentResume.resume_id)"
                ></i>
              </ng-container>

              <ng-container *ngIf="editingResumeId === studentResume.resume_id">
                <i class="bi bi-x cancel-icon ms-2" (click)="cancelEdit()"></i>
              </ng-container>
              </ng-container>

              <p>
                <i class="bi bi-clock"></i>
                {{studentResume.created_at | istResumeDate}}
              </p>

              <div class="card-actions">
                <button
                  class="view-btn"
                  (click)="goToResumeDetailPage(studentResume.resume_id)"
                >
                  View
                </button>

                <ng-container *hasPermission="PermissionForStudents.RESUME_DELETE">
                <i
                  class="bi bi-trash-fill delete ms-2"
                  (click)="deleteStudentResume(studentResume.resume_id)"
                ></i>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-3 font-name" *ngIf="page < totalPages">
        <button class="btn-add" (click)="loadMore()" [disabled]="isLoading">
          <ng-container *ngIf="isLoading; else showBtnText">
            <span class="spinner-border spinner-border-sm"></span> Loading...
          </ng-container>
          <ng-template #showBtnText>Load More</ng-template>
        </button>
      </div>
    </ng-container>
    <ng-template #noResumeFound>
      <p class="text-center mt-5 font-name">No Resume Found</p>
    </ng-template>
  </ng-template>
</div>
